export { default as LoadingBar } from './LoadingBar.vue'
